import {
  deriveSchemaMap,
  sameForVersions,
  type AnyDataFor,
  type DataFor,
  type KindOf,
  type RegistryShape,
  type VersionOf,
} from '../../../Interfaces/GenericViews/IGenericView';
import {
  legalTransactionRelationshipDataGenericV1,
  legalTransactionRelationshipDataSignatureCertificationV1,
} from '../ILegalTransactionRelationshipData';

import { GenericRelationshipDataView } from '../../../LegalTransaction/LegalTransactionRelationships/GenerischerDialog/GenericRelationshipDataView';
import { SignatureCertificationRelationshipDataView } from '../../../LegalTransaction/LegalTransactionRelationships/SignatureCertification/SignatureCertificationRelationshipDataView';

export const relationshipViewRegistry = {
  Unterschriftenbeglaubigung: {
    ...sameForVersions(
      legalTransactionRelationshipDataSignatureCertificationV1,
      SignatureCertificationRelationshipDataView,
      [1, 2] as const
    ),
  },
  'Allgemeine Anfrage': {
    ...sameForVersions(
      legalTransactionRelationshipDataGenericV1,
      GenericRelationshipDataView,
      [1, 2] as const
    ),
  },
} as const satisfies RegistryShape;

export type RelationshipType = KindOf<typeof relationshipViewRegistry>;
export type RelationshipVersion<K extends RelationshipType> = VersionOf<
  typeof relationshipViewRegistry,
  K
>;
export type RelationshipData<
  K extends RelationshipType,
  V extends RelationshipVersion<K>,
> = DataFor<typeof relationshipViewRegistry, K, V>;

export type ILegalTransactionRelationshipData = AnyDataFor<
  typeof relationshipViewRegistry
>;

export const relationshipSchemaMap = deriveSchemaMap(relationshipViewRegistry);
